import { AttendantCardMconf, AttendantCard, ScheduleCard } from "components";

import { ProcedureAttendantCard } from "components/ProcedureAttendantCard";
import { ProcedureScheduleCard } from "components/ProcedureScheduleCard";

import { ToastMessage } from "../../hooks/toast";
import { hearingTokensService } from "../../services/hearingTokens";

export const validTitle = (title: string, maxSize: number = 8) => {
  return title.substring(0, maxSize) + (title.length > maxSize ? "..." : "");
};

interface IListItemSchedule {
  listSchadule: Array<any>;
  hearingAttendants?: Array<any>;
  navigate: any;
  navigateTo: string;
  disabledCopy: boolean;
  disabledDelete: boolean;
  disabledEdit: boolean;
  disabledRecording: boolean;
  disabledCopyLink?: boolean;
  isProcedure?: boolean;
  isConfidentialAudience?: boolean;
  currentUserId?: number | null;
  onClickDelete: (e: any) => unknown;
  onClickEdit: (e: any) => unknown;
  onClickCopy: (e: any) => unknown;
  onClickRecoding?: (audiencias: any) => unknown;
}

export const listItemSchadule = ({
  listSchadule,
  hearingAttendants = [],
  navigate,
  navigateTo,
  disabledDelete,
  disabledCopy,
  disabledEdit,
  disabledRecording,
  disabledCopyLink = false,
  isProcedure = false,
  isConfidentialAudience = false,
  currentUserId,
  onClickRecoding,
  onClickDelete,
  onClickEdit,
  onClickCopy,
}: IListItemSchedule) => {
  const Card = isProcedure ? ProcedureScheduleCard : ScheduleCard;

  return listSchadule?.map((item: any, index) => {
    const attendantId = item?.attendantId;
    const hearingAttendant = hearingAttendants.find(
      (attendant) => Number(attendant?.attendantId) === Number(attendantId),
    );

    const title =
      isProcedure && item?.name ? item.name : `Agendado ${index + 1}`;
    const subTitle = isProcedure ? (hearingAttendant?.role ?? "") : "custodia";
    const creatorId = item?.userId;
    const disabledByConfidentialAudience =
      isProcedure &&
      isConfidentialAudience &&
      Number(creatorId) !== Number(currentUserId);
    const canCopy = disabledCopy && !disabledByConfidentialAudience;
    const canDelete = disabledDelete && !disabledByConfidentialAudience;
    const canEdit = disabledEdit && !disabledByConfidentialAudience;
    const canRecord = disabledRecording && !disabledByConfidentialAudience;

    return item.expectedDate !== null ? (
      <Card
        id={`record_schedule_${index}`}
        key={item?.id}
        title={title}
        subTitle={subTitle}
        day={item.expectedDate}
        time={item.expectedDate}
        agendaOpened={item.status !== 10}
        disabled={disabledByConfidentialAudience}
        onClickDelete={() => {
          if (!canDelete) return;
          onClickDelete(item);
        }}
        onClickEdit={() => {
          if (!canEdit) return;
          onClickEdit(item);
        }}
        onClickRecord={
          canRecord && onClickRecoding
            ? () => onClickRecoding(item)
            : canRecord
              ? () => navigate(`${navigateTo}/${item?.id}`)
              : () => {}
        }
        disabledCopy={!canCopy}
        disabledDelete={!canDelete}
        disabledEdit={!canEdit}
        disabledRecord={!canRecord}
        copyTooltip="Copiar link"
        onClickCopy={() => {
          if (!canCopy) return;
          onClickCopy(item?.id);
        }}
        squareWidth={100}
        hideCopyButton={disabledCopyLink}
      />
    ) : null;
  });
};

export const listAttendants = (
  listAttendant: Array<any>,
  audience: any,
  onClickDetach: (id: number) => unknown,
  permissionDetach: boolean,
  onClickCopyLinkAttendant: (data: any) => unknown,
  disabledCopy: boolean,
  disabledCard: boolean,
  isProcedure = false,
) =>
  listAttendant?.map((item, index) => {
    const Card = isProcedure ? ProcedureAttendantCard : AttendantCard;
    return (
      <Card
        id={`card_attedants_${index}`}
        key={item?.id}
        title={item?.name}
        subTitle={item.role}
        icon="avatar"
        disabled={disabledCard}
        onClickCopy={() => {
          if (disabledCard || disabledCopy) return;
          onClickCopyLinkAttendant(item);
        }}
        disabledCopy={disabledCard || disabledCopy || !item?.link}
        disabledDesfix={disabledCard || !permissionDetach}
        setSelectAttendant={
          disabledCard || !permissionDetach
            ? () => {}
            : () => onClickDetach(item?.id)
        }
        item={item}
      />
    );
  });

export const listAttendantsMconf = (
  listAttendant: Array<any>,
  audience: any,
  onClickDetach: (id: number) => unknown,
  permissionDetach: boolean,
  onClickCopyLinkAttendant: (data: any) => unknown,
  disabledCopy: boolean,
) =>
  listAttendant?.map((item, index) => {
    return (
      <AttendantCardMconf
        id={`card_attedants_${index}`}
        key={item?.id}
        title={item?.name}
        subTitle={item.role}
        icon="avatar"
        onClickCopy={() =>
          disabledCopy ? () => {} : onClickCopyLinkAttendant(item)
        }
        disabledCopy={disabledCopy || !item?.link}
        item={item}
      />
    );
  });

export const handleCopyMeetingLink = async (
  e: number,
  addToast: (messages: Omit<ToastMessage, "id">) => void,
) => {
  try {
    const { body, success } =
      await hearingTokensService.getOneByHearingFileId(e);

    if (success && body && body?.externalLink) {
      await navigator.clipboard.writeText(body.externalLink);

      addToast({
        type: "success",
        title: "Link copiado",
        description: "O link foi copiado com sucesso.",
      });
    } else {
      addToast({
        type: "warning",
        title: "Copiar link",
        description: "Não foi possivel copiar o link.",
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const showNotify = (audience: any) => {
  if (audience.foreignKey === null || audience.foreignKey === 0) {
    return false;
  } else {
    if (
      audience.status === "E" ||
      audience.status === "X" ||
      audience.status === "R"
    ) {
      return true;
    }
    return false;
  }
};
